import React, { useContext } from 'react'
import { Seo } from "src/components/seo";
import {
  Box,
  Container,
  Stack,
  Typography,
  Divider,
  Card,
  CardContent,
  ListItem,
  ListItemText,
  ListItemIcon,
  useTheme
} from "@mui/material";
import { Link } from 'react-router-dom';
import { WhiteLabelConfigurationContext } from 'src/contexts/ClientConfiguration';

const ZapierInstructions = () => {
  const { companyName} =useContext(WhiteLabelConfigurationContext);
  const theme=useTheme();

  return (
    <>
      <Seo title={`${companyName} Dashboard`} />

      <Box
        // component="main"
        // sx={{
        //   backgroundColor: (theme) => theme.palette.mode === 'dark'
        //     ? 'neutral.800'
        //     : 'neutral.50',
        //   pb: '120px',
        //   pt: '184px'
        // }}
        component="main"
        sx={{
          flexGrow: 1,
          height: "100%"
        }}
        
      >
        <Container maxWidth="xl" sx={{  pt: 2}}>
          <Stack spacing={3} sx={{ mb: 3 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{ color: theme.palette.text.primary, fontSize: "32px", fontWeight: "700" }}
                className="page-header"
              >
                {'Zapier Instructions'}
              </Typography>
            </div>

            <Divider />
          </Stack>

          <Box sx={{margin: "16px 0"}}>
            <ListItem sx={{marginBottom: 1}}>
              <ListItemIcon>
                {1}
              </ListItemIcon>
              <Typography sx={{color:theme.palette.text.primary}}>
              <p>
                {'To access your'} {" "} <span style={{ fontWeight: 700 }}>{`${companyName} account`}</span> {', please click on the'}&nbsp;
                <Link to={'/auth-main/login/v2'}>
                <Typography
      component="span"
      sx={{
        fontWeight: 700,
        textDecoration: "none",
        color: (theme) => theme.palette.primary.main,
        cursor: "pointer",
      }}
    >
      {"Sign In"}
    </Typography>
                </Link>&nbsp;
                {'button. This will direct you to the login page where you can enter your credentials to securely access your account and manage your business operations efficiently.'}</p>
              </Typography>
            </ListItem>
          </Box>

          <Box sx={{margin: "16px 0"}}>
            <ListItem sx={{marginBottom: 1}}>
              <ListItemIcon>
                {2}
              </ListItemIcon>
              <Typography sx={{color:theme.palette.text.primary}}>
                <p>{'Please select the'} <span style={{ fontWeight: 700 }}>{'Settings'}</span> {'button located at the bottom left of the sidebar.'}</p>
              </Typography>
            </ListItem>

            <Box
              alt="setttings"
              component="img"
              src="/assets/zapier-instructions/zapier-instructions-setttings.png"
              sx={{
                height: 'auto',
                maxWidth: '100%',
                width: "100%",
                border: "1px solid #f1f1f1",
                borderRadius: "20px"
              }}
            />
          </Box>

          <Box sx={{margin: "16px 0"}}>
            <ListItem sx={{marginBottom: 1}}>
              <ListItemIcon>
                {3}
              </ListItemIcon>
              <Typography sx={{color:theme.palette.text.primary}}>
                <p>{'In the Settings menu, please navigate to the'} <span style={{ fontWeight: 700 }}>{'Integrations'}</span> {'section by selecting the corresponding tab.'}</p>
              </Typography>
            </ListItem>
            
            <Box
              alt="integration"
              component="img"
              src="/assets/zapier-instructions/zapier-instructions-integration.png"
              sx={{
                height: 'auto',
                maxWidth: '100%',
                width: "100%",
                border: "1px solid #f1f1f1",
                borderRadius: "20px"
              }}
            />
          </Box>

          <Box sx={{margin: "16px 0"}}>
            <ListItem sx={{marginBottom: 1}}>
              <ListItemIcon>
                {4}
              </ListItemIcon>
              <Typography sx={{color:theme.palette.text.primary}}>
                <p>{'Next to the zapier logo, Click on the '} <span style={{ fontWeight: 700 }}>{'Switch Button'}</span> {'to turn it ON. The appearance of the switch should change to indicate that it is now in the ON position.'}</p>
              </Typography>
            </ListItem>
            
            <Box
              alt="switch"
              component="img"
              src="/assets/zapier-instructions/zapier-instructions-switch.png"
              sx={{
                height: 'auto',
                maxWidth: '100%',
                width: "100%",
                border: "1px solid #f1f1f1",
                borderRadius: "20px"
              }}
            />
          </Box>

          <Box sx={{margin: "16px 0"}}>
            <ListItem sx={{marginBottom: 1}}>
              <ListItemIcon>
                {5}
              </ListItemIcon>
              <Typography sx={{color:theme.palette.text.primary}}>
              <p><span style={{ fontWeight: 700 }}>{'The Zapier API Key'}</span>&nbsp;{'can be found below the Zapier logo. Please copy the Zapier API Key for use in the subsequent steps.'}</p>
              </Typography>
            </ListItem>
            
            <Box
              alt="token"
              component="img"
              src="/assets/zapier-instructions/zapier-instructions-token.png"
              sx={{
                height: 'auto',
                maxWidth: '100%',
                width: "100%",
                border: "1px solid #f1f1f1",
                borderRadius: "20px"
              }}
            />
          </Box>

          <Box sx={{margin: "8px 0"}}>
            <ListItem>
              <ListItemIcon>
                {6}
              </ListItemIcon>
              <span style={{ fontWeight: 700 }}>{'Access Zapier Account'}</span>
            </ListItem>
            <Typography sx={{color:theme.palette.text.primary}}>
            <ul style={{marginLeft: "24px"}}>
              <li><p>{'Login to'}&nbsp;<span style={{ fontWeight: 700 }}>{'Zapier'}</span>&nbsp;{'account.'}</p></li>
              <li><p>Once logged in, click on the <span style={{ fontWeight: 700 }}>{'Zap'}</span> button on the left sidebar of the dashboard.</p></li>
              <li><p>Cilck on <span style={{ fontWeight: 700 }}>{'Create'}</span> button to create a New Zap.</p></li>
              <li>
                <p>{`Assign a descriptive name to your Zap, such as "${companyName} Lead Access Integration," to help you easily identify it later. In the `}<span style={{ fontWeight: 700 }}>Choose trigger</span>{` section, type "${companyName}" in the search bar and select the ${companyName} app from the list of available apps.`}</p>
                
                <Box
                  alt="zapier choose trigger"
                  component="img"
                  src="/assets/zapier-instructions/zapier-instructions-choose-trigger.png"
                  sx={{
                    height: 'auto',
                    maxWidth: '600px',
                    width: "100%",
                    margin: "auto",
                    border: "1px solid #f1f1f1",
                    borderRadius: "20px"
                  }}
                />
              </li>

              <li>
                <p>{'Select Triggered app '}<span style={{ fontWeight: 700 }}> AI</span>{' and choose event from '}<span style={{ fontWeight: 700 }}>App & event</span>{' Tab. Click on Continue and move to the next step.'}</p>

                <Box
                  alt="zapier choose app event"
                  component="img"
                  src="/assets/zapier-instructions/zapier-instructions-choose-app-event.png"
                  sx={{
                    height: 'auto',
                    maxWidth: '600px',
                    width: "100%",
                    margin: "auto",
                    border: "1px solid #f1f1f1",
                    borderRadius: "20px"
                  }}
                />
              </li>

              <li>
                <p>{'In '}<span style={{ fontWeight: 700 }}>{'Account'}</span>{` Tab, If this is your first time using the ${companyName} app with Zapier, you will need to connect ${companyName} AI account. Click on the `}<span style={{ fontWeight: 700 }}>{"Sign in"}</span>{` button. A new window will appear, prompting you to enter your ${companyName} API key and Email Address. Retrieve this key from the API settings or integration section within your ${companyName} account.`}</p>

                <Box
                  alt="zapier popup prompt"
                  component="img"
                  src="/assets/zapier-instructions/zapier-popup-prompt.png"
                  sx={{
                    height: 'auto',
                    maxWidth: '600px',
                    width: "100%",
                    margin: "auto",
                    border: "1px solid #f1f1f1",
                    borderRadius: "20px"
                  }}
                />
              </li>
              <li><p>{'Enter the '} <span style={{ fontWeight: 700 }}>{'Zapier API key'}</span> {` in the provided field and authorize Zapier to access your ${companyName} account by clicking` } <span style={{ fontWeight: 700 }}>{'Yes, Continue'}</span></p></li>
            </ul>
            </Typography>
          </Box>

        </Container>
      </Box>
    </>
  )
}

export default ZapierInstructions
